// The closed vocabularies of an agent run row (CHT-715, docs/architecture/phase-4-agent-runtime.md, section 6.4). The row
// records the bounded state of one run: it holds no message text, prompt, tool call, tool result or memory.
/** `RUNNING` is the only open state. A run moves ONCE to one terminal state and never changes again. */
export const agentRunStatuses = Object.freeze([
    "RUNNING",
    "COMPLETED",
    "DEGRADED",
    "CANCELLED",
    "FENCED",
    "FAILED",
]);
export const agentRunRuntimeModes = Object.freeze(["fake", "live"]);
export const agentRunProfiles = Object.freeze(["INTERACTIVE", "BACKGROUND"]);
export const agentRunProviders = Object.freeze(["openai", "anthropic", "google", "fake"]);
/** A run that stays RUNNING longer than its deadline plus this margin is closed as abandoned (design 6.4). */
export const AGENT_RUN_ABANDONED_MARGIN_MS = 60_000;
/** The error code of a row that was closed as abandoned. */
export const AGENT_RUN_ABANDONED_CODE = "RUN_ABANDONED";
